import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { DEMO_SURVEY_URL, APP_URL } from '../../config/links'
import { SECONDARY_CTA_TEXT } from '../../config/cta'
import { Menu, X } from 'lucide-react'

const navigation = [
  { name: 'Industries', href: '/industries' },
  { name: 'Feedback Loops', href: '/feedback-loops' },
  { name: 'Pricing', href: '/pricing' },
  { name: 'About', href: '/about' },
  { name: 'Blog', href: '/blog' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  return (
    <header className="bg-white border-b border-intelligence-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/LOGO-TRANSPARENT-Prismscope.svg"
              alt="PrismScope"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === item.href
                    ? 'text-primary-600'
                    : 'text-intelligence-600 hover:text-intelligence-900'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href={APP_URL}
              className="text-sm font-medium text-intelligence-600 hover:text-intelligence-900"
            >
              Log In
            </a>
            <a
              href={DEMO_SURVEY_URL}
              className="px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors"
            >
              {SECONDARY_CTA_TEXT}
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden p-2 text-intelligence-600 hover:text-intelligence-900"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Open menu</span>
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-intelligence-200">
          <div className="px-4 py-4 space-y-3">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block py-2 text-base font-medium ${
                  location.pathname === item.href
                    ? 'text-primary-600'
                    : 'text-intelligence-600'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-intelligence-200 space-y-3">
              <a
                href={APP_URL}
                className="block py-2 text-base font-medium text-intelligence-600"
              >
                Log In
              </a>
              <a
                href={DEMO_SURVEY_URL}
                className="block w-full py-3 text-center text-base font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors"
              >
                {SECONDARY_CTA_TEXT}
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}
